// If an order is errored, wait for this time in case it becomes not errored again
export const LOADING_ORDER_TIMEOUT = 1000 * 30;  // 30 sec
